export default {
  path: 'temperatures',
  name: 'incubator.temperatures',
  component: () => import('@/views/admin/incubators/temperature-monitoring/Index'),
}